import { Button, Form } from 'antd';
import TextInput from '../inputs/TextInput';
import translations from '../../hooks/translation/translations.json';
import formDeleteDynamicError from '../../../utils/functions/formDeleteDynamicErrors';
import useTranslation from '../../hooks/translation/useTranslation';

function SocialLinksForm({
  handleSubmit, form,
}) {
  const { trans } = useTranslation();
  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={handleSubmit}
      onValuesChange={(values) => { formDeleteDynamicError({ form, values }); }}

    >
      <TextInput
        label="Instagram"
        name="instagram_url"
        rules={[{
          required: true,
          message: translations.ka.input_necessary,
        }]}
      />
      <TextInput
        label="Facebook"
        name="facebook_url"
        rules={[{
          required: true,
          message: translations.ka.input_necessary,
        }]}
      />
      <TextInput
        label="LinkedIn"
        name="linkedin_url"
        rules={[{
          required: true,
          message: translations.ka.input_necessary,
        }]}
      />
      <Form.Item>
        <Button type="primary" htmlType="submit">
          {trans('submit')}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default SocialLinksForm;
